import { c as _c } from "react/compiler-runtime";
import ProfileBadge from "@/components/common/profile/ProfileBadge";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { cicToType } from "@/helpers/Helpers";
import { isEthereumAddress, isAutoGeneratedHandle } from "@/helpers/AllowlistToolHelpers";
import type { ApiXTdhContribution } from "@/generated/models/ApiXTdhContribution";
import { formatXtdhRate, formatXtdhValue } from "../../../utils/formatters";
import { XtdhRatePill } from "../../../collection-card-content/subcomponents/XtdhRatePill";
interface XtdhTokenContributorsListItemProps {
  /**
   * Contribution row which either references a specific grant (flat view)
   * or represents a group of grants for a given grantor.
   */
  readonly contribution: ApiXTdhContribution;
  readonly onSelectGrant: (grantId: string, label: string) => void;
}
export function XtdhTokenContributorsListItem(t0) {
  const $ = _c(35);
  const {
    contribution,
    onSelectGrant
  } = t0;
  let t1;
  if ($[0] !== contribution.xtdh) {
    t1 = formatXtdhValue(contribution.xtdh);
    $[0] = contribution.xtdh;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const xtdhValue = t1;
  let t2;
  if ($[2] !== contribution.xtdh_rate) {
    t2 = formatXtdhRate(contribution.xtdh_rate);
    $[2] = contribution.xtdh_rate;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const xtdhRateValue = t2;
  const grantor = contribution.grant?.grantor ?? contribution.grantor ?? null;
  const grantorHandle = grantor?.handle ?? null;
  const tooltipIdentity = grantorHandle ?? grantor?.id ?? "";
  const displayHandle = grantorHandle ?? grantor?.primary_address ?? "Unknown grantor";
  const shouldTruncate = isEthereumAddress(displayHandle) || isAutoGeneratedHandle(displayHandle);
  const profileHref = grantorHandle ? `/${grantorHandle}` : undefined;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-text-xs tw-font-semibold tw-text-iron-400 tw-truncate">?</div>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const avatarFallback = t3;
  const t4 = grantor?.pfp;
  const t5 = grantor?.level ?? 0;
  const t6 = grantor?.cic ?? 0;
  let t7;
  if ($[5] !== t6) {
    t7 = cicToType(t6);
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = Boolean(profileHref);
  const t9 = grantorHandle ?? "Grantor profile";
  let t10;
  if ($[7] !== displayHandle || $[8] !== profileHref || $[9] !== t4 || $[10] !== t5 || $[11] !== t7 || $[12] !== t8 || $[13] !== t9) {
    t10 = <ProfileBadge handle={displayHandle} href={profileHref} pfpUrl={t4} level={t5} cicType={t7} avatarFallback={avatarFallback} asLink={t8} avatarAlt={t9} />;
    $[7] = displayHandle;
    $[8] = profileHref;
    $[9] = t4;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const grantorBadge = t10;
  let t11;
  if ($[15] !== grantorBadge || $[16] !== tooltipIdentity) {
    t11 = tooltipIdentity ? <UserProfileTooltipWrapper user={tooltipIdentity}>{grantorBadge}</UserProfileTooltipWrapper> : grantorBadge;
    $[15] = grantorBadge;
    $[16] = tooltipIdentity;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const grantorSummary = t11;
  const grantId = contribution.grant?.id;
  const isClickable = Boolean(grantId);
  const t12 = `tw-list-none tw-rounded-xl tw-border tw-border-solid tw-border-white/5  tw-bg-iron-900 desktop-hover:hover:tw-bg-iron-900/60 tw-p-4 tw-cursor-pointer tw-transition-all tw-duration-300  ${isClickable ? "tw-cursor-pointer desktop-hover:hover:tw-bg-iron-950 desktop-hover:hover:tw-border-white/10" : ""}`;
  let t13;
  if ($[18] !== displayHandle || $[19] !== grantId || $[20] !== onSelectGrant) {
    t13 = () => {
      if (grantId) {
        onSelectGrant(grantId, displayHandle);
      }
    };
    $[18] = displayHandle;
    $[19] = grantId;
    $[20] = onSelectGrant;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  const t14 = shouldTruncate ? "tw-max-w-40 md:tw-max-w-80 [&_p]:tw-truncate [&>div]:tw-min-w-0 [&>div>div]:tw-min-w-0" : "";
  let t15;
  if ($[22] !== grantorSummary || $[23] !== t14) {
    t15 = <div className="tw-flex tw-items-center tw-gap-3 tw-min-w-0"><div className={t14}>{grantorSummary}</div></div>;
    $[22] = grantorSummary;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== xtdhRateValue || $[26] !== xtdhValue) {
    t16 = <XtdhRatePill rateLabel={xtdhRateValue} totalLabel={xtdhValue} className="tw-justify-start lg:tw-justify-end lg:tw-w-[280px]" />;
    $[25] = xtdhRateValue;
    $[26] = xtdhValue;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t15 || $[29] !== t16) {
    t17 = <div className="tw-flex tw-flex-col tw-gap-3 lg:tw-flex-row lg:tw-items-center lg:tw-justify-between">{t15}{t16}</div>;
    $[28] = t15;
    $[29] = t16;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t12 || $[32] !== t13 || $[33] !== t17) {
    t18 = <li className={t12} onClick={t13}>{t17}</li>;
    $[31] = t12;
    $[32] = t13;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  return t18;
}